import { IAnimationStateData, IAnimationStateListener, IBoneData, IEvent, ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { IGenericFamilySpine, ISpineTrackAnimation } from "./IGenericFamilySpine";
import { FillingPotParams } from "./FillinPotParams";
import { Filter, LogGroup, Point, Scale, Size, randomInclusive, shuffle } from "../../MyHelpers";
import { AudioManager, ITrack, Track } from "../../AudioManager";
import { IInterval } from "../../Context/Interval";
import { IRandomTimeout } from "../../Context/RandomTimeout";
import { ITimeout } from "../../Context/Timeout";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Settings } from "../../Settings";
import { MultiBonusType, SlotGameBet } from "../../api";
import { IFillinPotFamilyFactory, FillingPotFamilyFeatureFactory } from "./FamilyFactory";
import { FillingPotPhysical } from "./FillingPotPhysical";
import { BonusWillUpdateFillingPotFeature, IFillingPotIncrements } from "./IFillingPotIncrement";
import * as PIXI from 'pixi.js'
import { EventData } from '@pixi-spine/runtime-4.1';
import { IIncrementSavePerBet, ILevelMultPot, ILevelsPerBetsSaved } from "./ILevelsPerBetSaved";
import { TweenMax, Power0 } from "gsap";
import { PotElementConstructive } from "./PotElementConstructive";
import { ILevelAnimation } from "./ILevelAnimationInterface";
import { PlaceHolderMutiPotConfig } from "./FillingPotGeneric";
import { CollectSRAPathFillingPot, PotCollectPosition } from "./CollectSRAPathFillingPot";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";

// interface ILevelAnimation {
//     level: number;
//     levelStartAnims: string[];
//     levelLoopAnims: string[];
// }

export const MultiPotName: string[] = [
    "Jackpot",
    "Double",
    "Multiplier",
]

export const MultiBonusMapSymbol: Record<string, string> = {
    "SRAJ":"Jackpot",
    "SRAD":"Double",
    "SRAM":"Multiplier"
    };

export class FamilyMultiBonusConstructiveFeature extends IGenericFamilySpine {   
    //protected view: HTMLElement = null;
    protected logGroup: LogGroup = null;
    protected resid: ResourceIdentifier = null;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    //protected availableLevelPerBet: ILevelsPerBetsSaved[] = [];
    protected gameResourcesBasePath: string = null;
    //protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
    protected audio: AudioManager = null;

    protected intervalSRAPathDebugger: IInterval = null;
    //protected restartStartIncrementLevelsOneTime: ITimeout = null;

    //protected currentLevelSaved = 0;
    protected spine: Spine = null;
    protected intervalLoopBigWin: ITimeout = null;
    protected startBonusWinFillingTimeOut: ITimeout = null;
    protected controlScalePoint: Point = null;
    protected animationBreathTrackAlphaMixFadeIn = { alphaMix: 0.4 };
    protected animationBreathTrackAlphaMixFadeOut = { alphaMix: 1 };
    //new used for split pot 
    protected potElements: Map<string, PotElementConstructive> = new Map<string, PotElementConstructive>();

    //protected currentRandomAnimationIndex: number = -1;
    protected allAnimationMap: Map<string, ISpineTrackAnimation> = new Map<string, ISpineTrackAnimation>();
    //protected startIndexRandomAnimation: number = null;
    protected animationArrayCollect: string[] = [];
    //protected animationArrayRASuffle: string[] = [];
    protected animationArrayBackground: string[] = [];
    //protected animationArrayRA: string[] = [];
    //protected lastindexAnimInterval: number = -1;
    protected animationRanbomTrack: ITrackEntry = null;
    protected countLevelAnimation: number = 0;
    //create for the Family-Constructive
    protected trackIndexAnimSpecialGameConnected = 0;
    protected trackIndexIDLE = 0;
    protected levelIndexAnim = 100;
    protected levelLoopIndexAnim = 100;
    //protected levelRAIndexAnim = 400;    
    protected backgroundIndexAnim = 80;
    protected collectStartTrackIndex = 5;
    protected hitpotArray: string[] = [];
    //readonly weightsIndexPot = [0.3, 0.5, 1];
    //readonly weightsHitOrNot = [0.5, 1];
    protected backgroundLiveSpineTimeout: ITimeout = null;
    //create anim for spine 
    protected countBonusAnim = 0;
    protected animatioBreathName: string = null;
    protected startBonusWin: boolean = false;
    protected randomAnimationIndex: number = 2;
    protected multiBonusLevelAnimationMap: Map<string, ILevelAnimation[]> = new Map<string, ILevelAnimation[]>();
    //only collect for constructive 1 time 
    //protected startIncrementLevelsOneTime: boolean = false;
    protected animationLevelTiming: number = 0;
    //protected currentLevelPlaying = 0;
    //protected availablePotLevelPerBet: Map<string, ILevelsMultiPotPerBetsSaved[]> = new Map<string, ILevelsMultiPotPerBetsSaved[]>();
    //protected selecteBet: SlotGameBet = null;
    //protected currentLevelPerBet: ILevelsPerBetsSaved = null;
    protected spinsForHitBonus: number = 50;
    //protected currentSpin: number = 0;
    protected percetageIncrementLevels: number = 0;
    //protected particlesCount: number = 0;
    protected bonusWinHasHitted: boolean = false;
    protected potIndex: number = 0;
    protected startWinShow: boolean = false;




    //CollectSRAPathFillingPot
    protected collectSRAPathFillingPot  : CollectSRAPathFillingPot = null;

    constructor(familyName: string, params: FillingPotParams, controlScalePoint: Point , spinnableReels : SpinnableReelsBigCanvas)  {
        super(params);
        //console.log(`${params.gameName}-FamilyType:`, familyName);
        //console.log(`${params.gameName}-Params:`, params);
        this.gameName = params.gameName;
        this.familyType = familyName;
        this.audio = params.audio;
        this.logGroup = params.logGroup.Add("FamilyConstructive");
        this.resid = params.resid.Add("FamilyConstructive");
        this.controlScalePoint = controlScalePoint;   
        //init bet levels and particles 
       


        //new init bet levels per pot 
        MultiPotName.forEach(bonus => {
            //used for split pots
            let potElement = new PotElementConstructive(bonus, params.initData.EnabledBets, params.initData.GameName, this.spinsForHitBonus, params.systemContext , params.gameResourcesBasePath, params.audio , params.resid)
            this.potElements.set(bonus, potElement);

            // let availableLevelPotPerBet: ILevelsMultiPotPerBetsSaved[] = [];
            // params.initData.EnabledBets.forEach((b) => {
            //     availableLevelPotPerBet.push({
            //         currentLevel: 0, //Math.floor(Math.random() * 100) + 1,
            //         TotalBet: b.TotalBetCents.InCents,
            //         currentSpin: 0,
            //         countLevels: 0,
            //         someLevelAnimISPlaying: false,
            //         currentLevelPlaying: 0,
            //     });
            // });
            //this.availablePotLevelPerBet.set(bonus, availableLevelPotPerBet);
            //console.log(``)
            potElement.OnLevelSetupFinishedAnim = (potName: string, currentLevelPlaying: number) => {
                //console.log(`pot-IncrementFinished : ${potName} - LevelPlaying ${currentLevelPlaying}`);
                this.hitpotArray = [];
                //if (this.hitpotArray.length > 0) this.IncrementLevels();

            }

            potElement.OnLevelSetupStartFinishedAnim = (potName: string, currentLevelPlaying: number) => {
                let animationDurationTrack: number = 1;
                if (this.allAnimationMap.has("LevelStartHit") == true && this.spine != null) {
                    let animationTrack = this.allAnimationMap.get("LevelStartHit");
                    animationDurationTrack = animationTrack.duration;
                    this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack)
                }
                if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                    this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, animationDurationTrack, this.spine);
                    //this.PlayAnimationSpine(this.animatioBreathName, 1, null);
                };
            }
        })




        this.gameResourcesBasePath = params.gameResourcesBasePath;

        let indexAnimationColletpath: number = 0;
        this.intervalSRAPathDebugger = params.systemContext.TimingContext().CreateInterval("pathSRA-Debugger", 1500, () => {
            if (indexAnimationColletpath < this.animationArrayCollect.length) {
                let animationTrack = this.allAnimationMap.get(this.animationArrayCollect[indexAnimationColletpath]);
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                indexAnimationColletpath++;
            } else {
                indexAnimationColletpath = 0;
                this.intervalSRAPathDebugger.Stop();
            }
        });

        // this.restartStartIncrementLevelsOneTime = params.systemContext.TimingContext().CreateTimeout("RestartStartIncrementLevelsOneTime", 1500, () => {
        //     this.startIncrementLevelsOneTime = false;
        // })

        this.startBonusWinFillingTimeOut = params.systemContext.TimingContext().CreateTimeout("StartBonusWinFillingTimeOut", 600, () => {
            this.spine?.state?.clearTrack(0);

            //this.spineTrackMap.get("collectHitBonus")?.PlayLoop(Track.LoopForEver);
            if (this.allAnimationMap.has("BN_BONUS") && this.spine?.state) {
                let animationTrack = this.allAnimationMap.get("BN_BONUS");
                this.allAnimationMap.get("BN_BONUS").isActive = true;
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                    this.AddQueueAnimation(this.animatioBreathName, 1, false, animationTrack.duration, this.spine);
                    //this.PlayAnimationSpine(this.animatioBreathName, 1, null);
                };
            }
            this.bonusWinHasHitted = false;
        });


        this.backgroundLiveSpineTimeout = params.systemContext.TimingContext().CreateTimeout("backgroundLiveSpineTimeout", 100, () => {
            for (let animIndexBG = 0; animIndexBG < this.animationArrayBackground.length; animIndexBG++) {
                let animationTrack = this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]);
                this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]).isActive = true;
                this.PlayAnimationSpine(this.animationArrayBackground[animIndexBG], animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            }
        });

        // this.changeRandomAnimationSpineInterval = params.systemContext.TimingContext().CreateRandomTimeout("changeAnimationInterval", 60000, 300000, () => {
        //     // if (this.animationArrayRASuffle.length > 0) {
        //     //     this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //     //     if (this.currentRandomAnimationIndex == this.animationArrayRASuffle.length - 1) {
        //     //         this.animationArrayRASuffle = shuffle(this.animationArrayRASuffle);
        //     //         //console.log("DoAnotherShuffledAnimation:", this.animationArrayRASuffle);
        //     //     }
        //     //     this.currentRandomAnimationIndex = (this.currentRandomAnimationIndex + 1) % this.animationArrayRASuffle.length;
        //     //     let animationTrack = this.allAnimationMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]);
        //     //     this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        //     //     let audio = this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex])
        //     //     audio?.Play(false);
        //     //     this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((animationTrack.duration * 1000) + 60000, (animationTrack.duration * 1000) + 300000);
        //     //     this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //     //     this.changeRandomAnimationSpineInterval.Start();
        //     //     audio = null;
        //     // }
        // });

        this.intervalLoopBigWin = params.systemContext.TimingContext().CreateTimeout("intervalLoopBigWin", 500, () => {
            if (this.allAnimationMap.has("EXPECTATION") == true && this.spine != null && this.startWinShow == true) {
                let animationTrack = this.allAnimationMap.get("EXPECTATION");
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            };
        });

        //Start Creating CollectPath Feature 
        this.collectSRAPathFillingPot = new CollectSRAPathFillingPot(spinnableReels , this.params.initData.PlayWindow , this.gameName,this.resid, this.audio);
        this.collectSRAPathFillingPot.OnCallBackFeatureFinished = (nameSRAFinished : string)=>{
            console.log("AnimFinished-Need Start Pot Anim ",nameSRAFinished);
               
            let potindex = MultiBonusMapSymbol[ nameSRAFinished];  
            if(potindex == null) return     
            this.potElements.get(potindex).WinPot();
        }
    }

    protected potCollectPosition : PotCollectPosition [] = [];
    public SetTargets(potCollectPosition: PotCollectPosition[])
    {
        this.potCollectPosition = potCollectPosition;
        this.collectSRAPathFillingPot.UpdateTargets(this.potCollectPosition);
    }


    //------------------------- PrepareResources and Load Reosurce ------------------------------------//

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        await this.potElements.forEach(pot=>pot.PrepareResources(resourceManager))
        await this.collectSRAPathFillingPot.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        await this.potElements.forEach(pot=>pot.ResourcesLoaded(resourceManager))
        await this.collectSRAPathFillingPot.ResourcesLoaded(resourceManager);
    }

    public override AddTrack(track: ITrack, nameTrack: string) {
        this.spineTrackMap.set(nameTrack, track);
    }

    //-------------------------Finish PrepareResources and Load Reosurce ------------------------------------//


    //------------------------- Create FillingPot and Setup , Init Anim  , Events , Destroy ------------------------------------//


    public override CreateAnimFamilyFeature(spineHit: Spine, app: PIXI.Application<HTMLCanvasElement>, placeHolderMutiPotConfig: PlaceHolderMutiPotConfig) {
        // //Check if spine hit was create ok 
        this.spine = spineHit;
        //if (spineHit != null) 
        {
            this.startBonusWin = false;

            //console.log("SpineHit-Animation:", this.spine.state.data.skeletonData.animations);

            this.spine.state.data.skeletonData.animations.forEach((anim, index) => {

                let spineTrackAnimation: ISpineTrackAnimation = {
                    trackAnimationIndex: 0,
                    loopAnimation: false,
                    soundTrack: null,
                    duration: 0,
                    animationName: "",
                    isActive: false
                }


                //this.allAnimationArray.push(anim);
                //search bonus per por , need to quit becuse is moved into potElements
                if (anim.name.match(new RegExp(/\//))) {
                    return
                }
                //this.allAnimationArray.push(anim);
                if (anim.name.includes("animationCollectPath_")) {
                    this.animationArrayCollect.push(anim.name);
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.trackAnimationIndex = index;
                }

                else if (anim.name.includes("RA_")) {
                    //this.animationArrayRASuffle.push(anim);
                   return
                }
                else if (anim.name.includes("BG_")) {
                    this.animationArrayBackground.push(anim.name);
                    spineTrackAnimation.loopAnimation = true;
                    spineTrackAnimation.trackAnimationIndex = index;
                }
                else if (anim.name.includes("IDLE_")) {
                    this.animatioBreathName = anim.name;
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                    spineTrackAnimation.loopAnimation = true;
                    spineTrackAnimation.animationName = anim.name;
                    spineTrackAnimation.isActive = true;
                }

                else if (anim.name.includes("Level_Full_Idle")) {
                    //this.animatioBreathName = anim.name;
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = true;
                    spineTrackAnimation.animationName = anim.name;
                    spineTrackAnimation.isActive = true;
                }

                else if (anim.name.includes("LevelStartHit")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
                }

                else if (anim.name.includes("LevelAnimation_Full_LevelStart")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
                }

                else if (anim.name.includes("LevelAnimation_Default")) {
                    spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim;
                    spineTrackAnimation.loopAnimation = true;
                }

                else if (anim.name.includes("EXPECTATION")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack = this.spineTrackMap.get("spineAnticipation");
                }

                else if (anim.name.includes("BN_BONUS")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitBonus");
                }

                else if (anim.name.includes("BN_START")) {
                    spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                    spineTrackAnimation.loopAnimation = false;
                    spineTrackAnimation.soundTrack = this.spineTrackMap.get("BN_START");
                }
                else if (anim.name.includes("_LevelStar")) {
                    // spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim + index;
                    // spineTrackAnimation.loopAnimation = false;    
                    // spineTrackAnimation.duration = anim.duration;
                    // spineTrackAnimation.animationName = anim.name;
                    //this.levelAnimationStatusMap.set(anim.name, spineTrackAnimation);     
                    return
                }
                else if (anim.name.includes("_Loop")) {
                    // spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim + index;
                    // spineTrackAnimation.loopAnimation = true;  
                    // spineTrackAnimation.duration = anim.duration;
                    // spineTrackAnimation.animationName = anim.name;
                    //this.levelAnimationStatusMap.set(animation.name, spineTrackAnimation);
                    return
                }



                spineTrackAnimation.duration = anim.duration;
                spineTrackAnimation.animationName = anim.name;
                this.allAnimationMap.set(anim.name, spineTrackAnimation);
            });

            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.allAnimationMap.get(this.animatioBreathName).isActive = true;
                this.PlayAnimationSpine(this.animatioBreathName, this.trackIndexIDLE, null);

            };

            // TODO we need to have animationCollectPath for each position on screen
            // if not, lets delete all animationCollectPath, so we don't use it

            let hasAll = true;

            for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++) {
                for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++) {
                    if (!this.allAnimationMap.has(`animationCollectPath_${reel}_${row}`)) {
                        hasAll = false;
                    }
                }
            }

            // if we don't have all animations for animationCollectPath, lets delete all and not use it
            if (!hasAll) {
                //this.animationArrayCollect = [];
                for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++) {
                    for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++) {
                        this.allAnimationMap.delete(`animationCollectPath_${reel}_${row}`);
                    }
                }
            }

            //




            if (this.animationArrayBackground.length > 0) {
                this.backgroundLiveSpineTimeout.Start();
            }

            //this.startIndexRandomAnimation = this.spine?.state?.data?.skeletonData?.animations?.findIndex(animation => animation.name.includes("RA_"))


            //.animationArrayRASuffle = shuffle(this.animationArrayRA);
            //arrayAnim = null;
            //console.log("Levels_allAnimationMap:", this.allAnimationMap);
            //console.log("StartRA_Animation Index:", this.startIndexRandomAnimation);
            //console.log("ShuffledAnimation:", this.animationArrayRASuffle);

            //Create interval for RA animation 
            // if (this.animationArrayRASuffle.length > 0) {
            //     this.changeRandomAnimationSpineInterval.Start();
            // }
            this.spineCompleteListener = {
                event: this.eventSpine,
                complete: this.AnimComplete,
                start: this.StartAnim
            }


            // Add an event listener to the Spine animation           
            this.spine?.state?.addListener(this.spineCompleteListener);




            //console.log("Spine-Constructive-Created",this.resid.ID());                 

            if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
                let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
                this.allAnimationMap.get(trackAnimation.animationName).isActive = true;
                this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = true;
                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
            }
            //this.SearchMultiBonusLevelsAnims();

            this.CreatePotElement(this.CheckInitDataPlaceHolder(placeHolderMutiPotConfig))
        }
        this.SetMixAnimation();
        this.CreateColletcSRAAnim(app.stage);
    }

    protected CreateColletcSRAAnim(stage: PIXI.Container<PIXI.DisplayObject>){
        this.collectSRAPathFillingPot.CreateViewPIXIAPP(this.spine);
        // stage.addChild(this.collectSRAPathFillingPot.ViewPIXIAPP());
    }
    public ViewPixiAPP(): PIXI.Container {
        return this.collectSRAPathFillingPot.ViewPIXIAPP();
    }

    protected CheckInitDataPlaceHolder(placeHolderMutiPotConfig: PlaceHolderMutiPotConfig) : PlaceHolderMutiPotConfig{
       placeHolderMutiPotConfig.loopWin == undefined ?placeHolderMutiPotConfig.loopWin = false : null;
       placeHolderMutiPotConfig.scaleX == undefined ?placeHolderMutiPotConfig.scaleX = 1 :placeHolderMutiPotConfig.scaleX;
       placeHolderMutiPotConfig.scaleY == undefined ?placeHolderMutiPotConfig.scaleY = 1 :placeHolderMutiPotConfig.scaleY;

       placeHolderMutiPotConfig.offsetX == undefined ?placeHolderMutiPotConfig.offsetX = 0 :placeHolderMutiPotConfig.offsetX;
       placeHolderMutiPotConfig.offsetY == undefined ?placeHolderMutiPotConfig.offsetY = 0 :placeHolderMutiPotConfig.offsetY;
       return placeHolderMutiPotConfig
    }

    //Create Pots
    protected CreatePotElement(placeHolderMutiPotConfig: PlaceHolderMutiPotConfig) {
        //new code       
        this.potElements.forEach((pot) => {
            pot.CreatePot(this.spine, placeHolderMutiPotConfig, this.spineTrackMap)            
        })
    }

    //SEt Mix Animation 
    protected SetMixAnimation(mixAnimationDuration: number = 0.1) {
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix(this.animatioBreathName, "LevelStartHit", mixAnimationDuration);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix(this.animatioBreathName, "EXPECTATION", mixAnimationDuration);
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix("LevelStartHit", this.animatioBreathName, mixAnimationDuration);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix("EXPECTATION", this.animatioBreathName, mixAnimationDuration);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix(this.animatioBreathName, "BN_START", mixAnimationDuration);
        if (this.allAnimationMap.has("BN_BONUS") && this.allAnimationMap.has(this.animatioBreathName)) this.spine?.state.data.setMix(this.animatioBreathName, "BN_BONUS", mixAnimationDuration);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has("BN_BONUS")) this.spine?.state.data.setMix("BN_START", "BN_BONUS", mixAnimationDuration);
    }

    protected ResetPoseSpine() {
        this.spine?.skeleton?.setBonesToSetupPose();
        this.spine?.skeleton?.setToSetupPose();
        this.spine?.skeleton?.setSlotsToSetupPose();
        this.spine?.update(0);
    }

    //create event for spine
    protected eventSpine = (trackIndex: ITrackEntry, event: IEvent) => {
        // Check if the event name matches your desired trigger                   
        let eventdata = event as unknown as EventData;
        //console.log(`Track EventData : ${{trackIndex}} `, trackIndex,eventdata);
        //console.log(`Track Event : ${{trackIndex}} `, trackIndex,event);

        //stops animation when pathAnim its finished
        if (eventdata.stringValue == "pathStart") {
            //this.audio.Play(this.resid.ScopedResourceName("collectHitStartSound"));
            this.spineTrackMap.get("collectHitStartSound").Play();
        }
        else if (eventdata.stringValue == "pathFinished") {
            // //play sound for finish path collect anim    
            // //this.hitpotArray = [];
            // // if (this.hitpotArray.find(ele => ele == MultiNamesAnimationLV[this.weightsIndexPot.findIndex(p => Math.random() < p)])) return
            // // this.hitpotArray.push(MultiNamesAnimationLV[this.weightsIndexPot.findIndex(p => Math.random() < p)]);
            // if (this.hitpotArray.length > 0 ) {
            //     //console.log(`RandomPotHit`, this.hitpotArray);                
            //     this.IncrementLevels()                
            // };
        }
        eventdata = null;
        trackIndex = null;
    };

    protected spineCompleteListener: IAnimationStateListener = null;

    protected AnimComplete = (trackComplete: ITrackEntry) => {
        this.potElements.forEach(pot => {
            //const anim = trackComplete.animation;
            if (pot.levelAnimationStatusMap.has(trackComplete.animation.name) == true) {
                pot.AnimComplete(trackComplete)
            }
        });

        //const anim = trackComplete.animation;
        if (this.allAnimationMap.get(trackComplete.animation.name)?.loopAnimation == true && this.allAnimationMap.has(trackComplete.animation.name) == true) {
            let trackAnimation = this.allAnimationMap.get(trackComplete.animation.name);
            this.PlayAnimationSpine(trackAnimation.animationName, trackComplete.trackIndex, trackAnimation.soundTrack, null, true, trackComplete);
        }
        //else {
        //if(trackComplete.trackIndex == 0 ) return 
        //this.spine?.state?.clearTrack(trackComplete.trackIndex);
        //}
        //console.log(`tracksAnims`, this.tracksEnabled);
    }

    protected StartAnim = (trackComplete: ITrackEntry) => {
    }

    protected SetDefaultAnimation() {
        // if (this.spine == null) return
        // let anim: ITrackEntry = null;
        // //console.log("BETLEVEL:", this.currentLevelSaved)
        // if (this.currentLevelSaved == 0) {
        //     if (this.allAnimationMap.has("LevelAnimation_Default") == true && this.spine != null) {
        //         let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
        //         this.allAnimationMap.get(trackAnimation.animationName).isActive = true;
        //         this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = true;
        //         this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
        //     }
        // } else if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
        //     let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
        //     this.allAnimationMap.get(trackAnimation.animationName).isActive = false;
        //     this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = false;
        //     //this.spineHit?.state?.clearTrack(trackAnimation.trackAnimationIndex);
        // }

    }

    public override Destroy() {    
        if(this.spineCompleteListener) this.spine?.state?.removeListener(this.spineCompleteListener);
        this.collectSRAPathFillingPot.DestroyPIXIAPP();
        this.potElements.forEach(pot=>pot.Destroy());
        //this.animationArrayRASuffle = [];
        this.animationArrayBackground = [];
        this.animationArrayCollect = [];
       // this.animationArrayRA = [];
        this.multiBonusLevelAnimationMap.clear();
        //this.lastindexAnimInterval = null;
        //this.currentRandomAnimationIndex = null;      
        //this.changeRandomAnimationSpineInterval?.Stop();
        this.backgroundLiveSpineTimeout?.Stop();
        //this.changeRandomAnimationSpineInterval?.Stop();      
        this.intervalSRAPathDebugger?.Stop();
        this.bonusWinHasHitted = false;
        this.startBonusWin = false;
        this.multiBonusLevelAnimationMap.clear();
        this.hitpotArray = [];
        
    //     if (  this.spine.parent) {
    //         this.spine.parent.removeChild(  this.spine);
    //   }
    //   this.spine = null;
    }

    protected PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, soundTrack: ITrack, speedAnimation: number = null, loopAnim: boolean = false, trackComplete?: ITrackEntry) {
        if (loopAnim == true && !trackComplete == true) {
            trackComplete.trackTime = 0;
            soundTrack?.Play(false);
            return
        }
        else {
            this.spine?.state?.addEmptyAnimation(trackAnimationIndex, 0, 0);
            this.spine?.state?.setEmptyAnimation(trackAnimationIndex, 0);
            let trackAnimation = this.spine?.state?.setAnimation(trackAnimationIndex, nameAnimation, false);
            if (trackAnimation && speedAnimation != null) {
                trackAnimation.timeScale = speedAnimation;
            }
            //this.allAnimationMap.get(nameAnimation).trackAnimationIndex = trackAnimationIndex;
            soundTrack?.Play(false);
        }
    }

    public Update(): void {
    }

    //--------------------------  Finish Create FillingPot and Setup , Init Anim  , Events , Destroy  ---------------------------//



    //--------------------------- Increments , Bets , Clear Levels , ---------------------------------------//

    /** set new increment for change scale for part in spine */
    public StartIncrement(fillingPotIncrements: IFillingPotIncrements): void {
        //play animation path depends reel and row index 
        if (!this.spine) {
            // no spine
            return;
        }

        // let seen = new Set();
        //     let filterSRA = fillingPotIncrements.winSymbols.map(subArray=>{
        //         return subArray.filter(item=>{
        //             if (!seen.has(item)) { // Si el elemento no se ha visto antes
        //                 seen.add(item); // Agregarlo al conjunto de elementos vistos
        //                 return item; // Mantenerlo en el subarreglo
        //               }
        //               return null; // Eliminarlo si ya existe
        //         })
        //     })

        // seen = null
        //let animationCollectPath : ITrackEntry = null;
        fillingPotIncrements.ScatterCordinates?.forEach(s => {
            this.collectSRAPathFillingPot.ShowSRAAnim(s.Reel,s.Row , fillingPotIncrements.winSymbols[s.Reel][s.Row]);
            //const animationName = `animationCollectPath_${s.Reel}x${s.Row}`;
            //console.log("SRA-FindSymbol",MultiBonusMapSymbol[fillingPotIncrements.winSymbols[s.Reel][s.Row]]);            
            
            let potindex = MultiBonusMapSymbol[ fillingPotIncrements.winSymbols[s.Reel][s.Row]];  
            if(potindex == null) return     
            if(this.hitpotArray.find(p=>p == potindex)) return      
            this.hitpotArray.push(potindex);              
            //this.potElements.get(potindex).WinPot();
            //this.potElements.get(potindex).UpdateSpinPotElemet();   
            potindex = null;               

            // //let trackIndex: number = this.allAnimationMap.get(animationName).trackAnimationIndex + this.collectStartTrackIndex;            
            // let trackAnim = this.allAnimationMap.get(animationName);
            // this.PlayAnimationSpine(animationName, trackAnim.trackAnimationIndex, trackAnim.soundTrack, 1.7);          
        });

        this.IncrementLevels();
        //console.log("Play-HitPotArray:",this.hitpotArray)
    }

    protected IncrementLevels() {
        if (this.spine == null) return


        for (let pot of this.hitpotArray) {
            //this.audio.Play(this.resid.ScopedResourceName("collectHitSound"));        
            if (this.bonusWinHasHitted == false && this.potElements.get(pot).isPosibleHitNextLevel() == true && this.potElements.get(pot).IsFullLevel() == false) {
                
                //search the pot that was hitted 
                // if (potIndex != null) {
                //     let pot = this.potElements.get(MultiPotName[potIndex])
                //     pot.IncrementLevels();
                //     pot = null;
                // }


                this.potElements.get(pot).IncrementLevels()


            }
            else if (this.potElements.get(pot).IsFullLevel() == true) {

                if (this.hitpotArray.length > 0) {
                    // let pot = this.potElements.get(MultiPotName.find(pot => pot == this.hitpotArray[0]));
                    // this.hitpotArray.shift();
                    // pot.IncrementLevels();
                    // pot = null;


                    this.potElements.get(pot).IncrementLevels()

                }

                //LevelFull- Check if poppet have some full level
                let delayFullLevel: number = 1;
                if (this.allAnimationMap.has("LevelAnimation_Full_LevelStart") == true) {
                    let trackAniamtion = this.allAnimationMap.get("LevelAnimation_Full_LevelStart");
                    this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
                    delayFullLevel += trackAniamtion.duration;
                    trackAniamtion = null;

                }

                




                if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                    this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, delayFullLevel, this.spine);
                };
                //if (this.hitpotArray.length > 0) this.IncrementLevels(MultiNamesAnimationLV.findIndex(pot => pot == this.hitpotArray[0]));
                delayFullLevel = null;
            }
        }
        //Save currentLevel by percentaje
        this.SaveCurrentIncrement();
        //this.restartStartIncrementLevelsOneTime.Start();
    }

    /** use for SetBet and change timeTrack per bet for Spine if you was played and hit some SRA */
    protected selectedBet: SlotGameBet = null;
    public SetBet(selectedBet: SlotGameBet) {      
        //this.SetDefaultAnimation();
        this.ClearLevels();
        this.ResetPoseSpine();
        //new code split by code 
        let somePotHasLevel : boolean = null;
        this.potElements.forEach(pot => {
            pot.SetBetByLevel(selectedBet);
            if(pot.GetCurrentLevels().levelPerBet.find(s=>s.TotalBet == selectedBet.TotalBetCents.InCents).currentLevel > 0) somePotHasLevel = true;
        });

        let delayIdle = 1;
        if (this.allAnimationMap.has("LevelStartHit") == true && this.spine != null && somePotHasLevel == true) {
            let animationTrack = this.allAnimationMap.get("LevelStartHit");       
            delayIdle = animationTrack.duration;   
            this.AddQueueAnimation(animationTrack.animationName , animationTrack.trackAnimationIndex , false , 0 , this.spine)              
        }

         
        if (this.allAnimationMap.has(this.animatioBreathName) == true && somePotHasLevel == true) {
            this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, delayIdle, this.spine);
        };

        this.selectedBet = selectedBet;
    }

    protected ClearLevels() {
        this.potElements.forEach(pot => pot.ClearLevels())
    }

    public UpdateSpin() {   
        //new code split by pot 
        // this.potElements.forEach(pot => {
        //     pot.UpdateSpinPotElemet()
        // })
    }

    /** save new increment per denom its missing add per pet */
    public SaveCurrentIncrement() {     
        //this.SavePotCurrentIncrement();
          this.potElements.forEach(pot => {
            pot.UpdateSpinPotElemet()
        })
    }

    /** save new increment per Pot and per bet */
    protected SavePotCurrentIncrement() {
        // this.potElements.forEach(pot => {
        //     pot.UpdateSpinPotElemet()
        // })
        //console.log("Levels_Saved_AllLevels:", this.availablePotLevelPerBet);
    }

    public GetCurrentLevels(): IIncrementSavePerBet {
        let levelMultPot: ILevelMultPot[] = [];

        this.potElements.forEach(pot => {
            levelMultPot.push(pot.GetCurrentLevels());
        });
        return {
            familyParticles: null,
            familyConstructive: null,
            familyConstrutiveMultPot: levelMultPot
        }
    }

    public SetCurrentFromBaseGameLevels(incrementSavePerBet: IIncrementSavePerBet) {        
        //console.log("SaveValues-FromBaseGames:",incrementSavePerBet)
        if (incrementSavePerBet != null)  this.potElements.forEach(pot => pot.SetCurrentFromBaseGameLevels(incrementSavePerBet.familyConstrutiveMultPot.find(increment => increment.potName == pot.GetName()).levelPerBet))
    }

    protected ClearLastLevel() {

        this.potElements.forEach(pot => {
            pot.ClearLastLevel();
        })

    }

    //--------------------------- Finis Increments , Bets , Clear Levels , ---------------------------------------//





    //--------------------------- Events Conects whit Game , Bonus , Anticipation , End Anticipation , BigWin-------------------//

    public StartBonusWin(bonusName: string ,  bonusVariantName : MultiBonusType[] , multiplier : number) {
        if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
            let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
            this.allAnimationMap.get(trackAnimation.animationName).isActive = false;
            this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = false;
            //this.spineHit?.state?.clearTrack(trackAnimation.trackAnimationIndex);                
        }

        this.startBonusWin = true;
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.intervalLevelRAAnimation?.Stop();
        //this.startRALevelLoopTimeout?.Stop();
        //this.startIntervalCheckNextLevelAnimation.Stop();



        if(bonusVariantName?.length <= 0 ) return;
        //BonusWillUpdateFillingPotFeature.forEach(b => {
        if (BonusWillUpdateFillingPotFeature.includes(bonusName)) {
            this.bonusWinHasHitted = true;
            bonusVariantName?.forEach(bonusHit =>{
                this.potElements.get(bonusHit).StartBonusWin(multiplier);
            });           

            if (this.allAnimationMap.has("BN_START") && this.spine?.state) {
                let animationTrack = this.allAnimationMap.get("BN_START");
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                this.startBonusWinFillingTimeOut.ChangeTimeout((animationTrack.duration * 1000) + 500)
            }
            this.startBonusWinFillingTimeOut?.Start();
        }
        //});

        this.SaveCurrentIncrement();
    }

    //protected animationExpectation : ITrackEntry = null
    public StartAnticipationBegin() {
        //this.changeRandomAnimationSpineInterval?.Stop()
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spine != null) {
            let trackAnimation = this.allAnimationMap.get("EXPECTATION");
            this.allAnimationMap.get("EXPECTATION").isActive = true;
            this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack)
            //this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((trackAnimation.duration * 1000) + 60000, (trackAnimation.duration * 1000) + 300000)
            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, trackAnimation.duration, this.spine);
            };
        }

        this.potElements.forEach(pot => {
            pot.StartAnticipationBegin()
        });
    }

    public EndAnticipationBegin() {
        //this.changeRandomAnimationSpineInterval?.Start();
        //this.animationExpectation.loop = false ;                 
        this.potElements.forEach(pot => {
            pot.EndAnticipationBegin()
        });
    }

    /** pause loop anim*/
    public StopAnim(): void {
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.audio.Stop(this.resid.ScopedResourceName("collectHitBonus"));
        //this.spineTrackMap.get("collectHitBonus")?.Stop();
        if (this.allAnimationMap.has("BN_BONUS")) {
            this.allAnimationMap.get("BN_BONUS").isActive = false;
            this.allAnimationMap.get("BN_BONUS").loopAnimation = false;
        }
        //this.SaveCurrentIncrement();        
    }

    /** restart loop anim */
    public RestartAnim(): void {
        //this.changeRandomAnimationSpineInterval?.Start();
        //this.intervalLevelRAAnimation?.Start();
    }

    public OnStartBigWinShow() {
        //this.changeRandomAnimationSpineInterval?.Stop();
        this.startWinShow = true;
        //if (this.allAnimationMap.has("EXPECTATION") == true) this.allAnimationMap.get("EXPECTATION").isActive = true;
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spine != null && this.startWinShow == true) {
            let animationTrack = this.allAnimationMap.get("EXPECTATION");
            //this.allAnimationMap.get("EXPECTATION").isActive = true;
            this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0, this.spine);
            };
        };
    }

    public OnEndBigWinShow() {
        if (this.startWinShow == true) {
            //this.changeRandomAnimationSpineInterval?.Restart();
            this.startWinShow = false;
        }
    }


    //---------------------------End  Events Conects whit Game , Bonus , Anticipation , End Anticipation , -------------------//





    //---------------------------- Debugger for filling pot ----------------------------------- // 

    public LevelDebuggerTest(levelTestit: number, potIndex: number) {
        if (potIndex == null) return
        if (levelTestit != null) {
            if (potIndex != null) {
                let pot = this.potElements.get(MultiPotName[potIndex])
                if (levelTestit > pot.GetAllLevels()) { console.log(`Check the LevelAnimation for pot ${pot.GetName()} debbug , only have ${pot.GetAllLevels()} Levels , try a less number`); return; }
                pot.LevelDebugger(levelTestit);
                this.hitpotArray.push(this.potElements.get(MultiPotName[potIndex]).GetName())
                this.IncrementLevels();
            }
        }
        //else { this.percetageIncrementLevels++ }

    }

    public PathDebuggerTest(command: string) {
        if (command == "pathsra") {
            let randomPath = this.animationArrayCollect.filter(anim => anim.includes("animationCollectPath_")).random();
            let animationTrack = this.allAnimationMap.get(randomPath);
            this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        } else {
            if (this.intervalSRAPathDebugger.Running() != true) this.intervalSRAPathDebugger.Start();
        }
    }



    public override FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: RegExpMatchArray) {
        // this.changeRandomAnimationSpineInterval.Stop();
        // let indexRA = parseInt(numberAnimToPlay[0]) - 1
        // if (indexRA < this.animationArrayRA.length) {
        //     console.log("FamilyConstructive-AnimationRATOPlay:", this.animationArrayRA[indexRA]);

        //     let animationTrack = this.allAnimationMap.get(this.animationArrayRA[indexRA]);
        //     this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack)
        //     let audio = this.spineTrackMap.get(this.animationArrayRASuffle[indexRA]);
        //     if (audio != null) audio.Play(false);
        //     console.log("FamilyConstructive-AnimationRATOPlay-Sound:", this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]));
        //     setTimeout(() => {
        //         this.changeRandomAnimationSpineInterval.Start();
        //     }, (animationTrack.duration * 1000) + 5500);
        // } else {
        //     console.log("RA_Anim Dose't exist , change index :  1 to 10 , availablesRA :", this.animationArrayRA.length);
        // }
    }

    //----------------------------End Debugger for filling pot ----------------------------------- //     

    public RamclearFillingPot(selecteBet: SlotGameBet){
        this.potElements.forEach(p=>p.RamclearLevel(selecteBet));
    }


    public override ReelStops(winSymbolsReelStop : string[]): void {       
        winSymbolsReelStop.filter(Filter.UniqueItem).forEach(s=>this.potElements.get(MultiBonusMapSymbol[s])?.ReelStops());
    }
    public override ParticlesDebugger() {
        //throw new Error("Method not implemented.");
    }

    override UpdateTargetsGlobal(potCollectPosition: PotCollectPosition[]): void {
        this.collectSRAPathFillingPot?.UpdateTargetsGlobal(potCollectPosition);
    }

    public override OnResize(): void {
        this.collectSRAPathFillingPot?.OnResize();
    }
}
